import clsx from 'clsx';
import {map} from 'lodash';
import {useState} from 'react';

import BarChart from 'components/Chart/Bar';
import KyError from 'components/Errors/KyError';
import Loading from 'components/Loading';
import ReadableWidthTemplate from 'components/Templates/ReadableWidth';
import {useGet} from 'helpers/KyHooks';
import StatsForm from 'pages/public/stats/Form';

import './index.scss';


export default function StatsPage() {
  const [data, setData] = useState(null);
  const {response, error} = useGet('api/v1/techStacks/list', {
    cacheResponse: false,
  }, {
    transform: (r) => map(r?.data?.techStacks, (val) => ({
      label: val?.techStackName,
      value: val?.techStackName,
      category: val?.category,
    })),
  });
  
  const saveHandler = (val) => {
    setData(val?.data?.stats?.stats);
  };
  
  let body = <Loading />;
  if (response) {
    body = <StatsForm techStacks={response} onSave={saveHandler} />;
  } else if (error) {
    body = <KyError kyError={error} />;
  }
  
  return (
    <ReadableWidthTemplate title="" className="statsPage">
      {body}
      {renderStats(data)}
    </ReadableWidthTemplate>
  );
}

function renderStats(stats) {
  if (!stats) {
    return null;
  }

  const data = map(Object.keys(stats), (type) => ({label: type, value: stats[type]}));
  
  return (
    <figure className={clsx('caFigure')}>
      <BarChart
        data={data}
        showLabels={true}
        horizontal={false}
        style={{height: '300px'}}
      />
      <figcaption className="text-center text-muted">
        Count of tech stack by company.
      </figcaption>
    </figure>
  );
}
